import mitt, { Emitter } from 'mitt';

type Events = {
  triggerClose: string | undefined;
  anErrorOccurred: undefined;
  success: string;
  error: string;
};

export const eventBus: Emitter<Events> = mitt<Events>();
